import { bl_fi_mst_set_of_books_hdr_RowClass } from '../../../dbschema/bl_fi_mst_set_of_books_hdr.model';
import { bl_fi_mst_set_of_books_line_RowClass } from '../../../dbschema/bl_fi_mst_set_of_books_line.model';
import {BaseContainerModel} from '../../base-container.model';


export class SetOfBooksLineContainerModel extends BaseContainerModel {
  bl_fi_mst_set_of_books_lines: bl_fi_mst_set_of_books_line_RowClass[] = [];
}
